import React from "react";
import { useState } from "react";
import { useQuery } from "react-query";
import { GetTimelineApi } from "../../Services/Timeline";
import { Card, Spinner, Alert, Row, Col } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import "./Timeline.css"; // Updated CSS file for enhanced styling

const Timeline = () => {
  const { data, isLoading, isError } = useQuery("getTimeline", GetTimelineApi, {
    refetchOnWindowFocus: false,
  });

  const [timelinesCount, setTimelinesCount] = useState(() => {
    return sessionStorage.getItem("timelinesCount") || 0;
  });
  
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (isError) {
    return (
      <Alert variant="danger" className="text-center">
        Failed to load timeline data. Please try again later.
      </Alert>
    );
  }

  return (
    <div className="timeline-container">
      {data?.slice().reverse().map((item, index) => (
        <div key={item.ID} className={`timeline-item ${index < timelinesCount ? "highlighted" : ""}`}>
          {index > 0 && (
            <div className="timeline-icon">
              <FaCircle />
            </div>
          )}
          <Card className={`mb-4 shadow timeline-card ${index < timelinesCount ? "highlighted-card" : ""}`}>
            <Card.Body>
              <Row>
                <Col className="text-start">
                  <span className="blue-text">
                    {item.ACTION_DATE !== "0001-01-01T00:00:00" ? item.ACTION_DATE.split("T")[0] : "N/A"}
                  </span>
                </Col>
                <Col className="text-end">
                  <span className="blue-text">
                    {item.ACTION_TIME !== "00:00:00" ? item.ACTION_TIME : "N/A"}
                  </span>
                </Col>
              </Row>
              <Card.Title className="mt-2">{item.ACTION}</Card.Title>
            </Card.Body>
          </Card>
          {index < data.length - 1 && (
            <div className="timeline-line">
              <div className="line"></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Timeline;
